import ModalVideo from 'react-modal-video';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
export default function HomeFiveCta(){
    const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
    return(
		<>
			<ModalVideo channel='youtube' isOpen={isOpen} videoId='S05bHj0LBE4' onClose={() => { openModal(); }} />
			<section class="cta-area cta-full5 home-5">			 
				<div class="container">
					<div class="cta-bg5">
						<div class="row text-left">
						
							<div class="col-xxl-5 col-xl-4 col-lg-4"></div>
							<div class="col-xxl-7 col-xl-8 col-lg-8 col-md-12">
								<div class="cta-wrapper">
									<h2 class="sect-title5 text-white">
										Convey the pleasure of an performing magnificent moments &amp; rising up the top.</h2>
										<div class="about-video-wrapper">
											<Link onClick={() => { openModal(); }} href="#" class="popup-video">
												<i class="far fa-play"></i>
											</Link>
										</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>       
    )
}